import { Grid, Card, CardContent, Typography, CardActions } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RegionForm } from 'system/geographic/pages/region/list/types';
import * as yup from 'yup';
import { PmiButton } from 'shell/components/shared/button';
import { useFormik } from 'formik';
import { useCallback } from 'react';
import PmiTextField from 'shell/components/shared/text-field';

interface FormRegionPops {
  title: string;
  disabled?: boolean;
  onSave?: (form?: RegionForm) => void;
  initialValues?: RegionForm;
  isEdit?: boolean;
}

const validationSchema = yup.object({
  name: yup.string().required('Il campo nome è obbligatorio'),
  code: yup.string().required('Il campo codice è obbligatorio'),
});

const FormRegion = ({
  title,
  disabled,
  initialValues,
  isEdit = false,
  onSave,
}: FormRegionPops): React.ReactElement => {
  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues) => {
      if (onSave) {
        onSave(formValues);
      }
    },
    [onSave]
  );

  const regionForm = useFormik({
    initialValues: initialValues || {
      name: '',
      code: '',
    },
    validationSchema: validationSchema,
    onSubmit,
  });

  return (
    <Card raised className="pmi-my-3">
      <form onSubmit={regionForm.handleSubmit}>
        <CardContent style={{ padding: '24px' }}>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          <div style={{ padding: '24px 0 0 0' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <PmiTextField
                  aria-label="Codice regione"
                  label="Codice regione *"
                  id="code"
                  name="code"
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputProps={{
                    maxLength: '3',
                    pattern: '[0-9]*',
                  }}
                  value={regionForm.values.code || ''}
                  onChange={(event) =>
                    regionForm.setFieldValue(
                      'code',
                      event.target.validity.valid ? event.target.value : regionForm.values.code
                    )
                  }
                  error={regionForm.touched.code && Boolean(regionForm.errors.code)}
                  helperText={regionForm.errors.code}
                  disabled={disabled || isEdit}
                />
              </Grid>
              <Grid item xs={12} md={9}>
                <PmiTextField
                  aria-label="Nome regione"
                  label="Nome regione *"
                  id="name"
                  name="name"
                  fullWidth
                  type="text"
                  inputProps={{
                    maxLength: '24',
                  }}
                  variant="outlined"
                  value={regionForm.values.name || ''}
                  onChange={regionForm.handleChange}
                  error={regionForm.touched.name && Boolean(regionForm.errors.name)}
                  helperText={regionForm.errors.name}
                  disabled={disabled}
                />
              </Grid>
            </Grid>
          </div>
        </CardContent>
        <CardActions style={{ padding: '24px 24px 16px 24px' }}>
          <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
            Conferma
          </PmiButton>
          <PmiButton
            variant="outlined"
            color="cdmBrand"
            onClick={() => {
              navigate('/sistema/geografiche/italia/regione');
            }}
          >
            Indietro
          </PmiButton>
        </CardActions>
      </form>
    </Card>
  );
};

FormRegion.displayName = 'Form region';

export default FormRegion;
